export function createCarMarkerContent(iconUrl: string, carId: string, labelColor = '#ffffff'): HTMLElement {
    const marker = document.createElement('div');
    marker.className = 'advanced-car-marker';

    const icon = document.createElement('img');
    icon.alt = '';
    icon.draggable = false;
    icon.src = iconUrl;
    marker.appendChild(icon);

    const label = document.createElement('span');
    label.textContent = carId;
    label.style.color = labelColor;
    marker.appendChild(label);
    return marker;
}

export function createRouteMarkerContent(
    label: string,
    background: string,
    glyphColor = '#ffffff',
    size: 'small' | 'regular' | 'large' = 'regular'
): HTMLElement {
    const marker = document.createElement('div');
    marker.className = `advanced-route-marker advanced-route-marker--${size}`;
    marker.style.setProperty('--advanced-marker-background', background);
    marker.style.setProperty('--advanced-marker-glyph', glyphColor);

    if (label !== '') {
        const glyph = document.createElement('span');
        glyph.textContent = label;
        marker.appendChild(glyph);
    }
    return marker;
}
